import Modal from 'ds/components/modal';
import React from 'react';
import { useScreenBreakpoint } from 'consts/breakpoints';


export const ModalWrapper: React.FC<{ isOpen: boolean; onClose: () => void; children: React.ReactNode; }> = ({ isOpen, onClose, children }) => {
  const screen = useScreenBreakpoint();
  const isDesktop = screen >= 3;

  if (!isOpen) return null;

  return (
    <Modal
      isOpen
      onClose={onClose}
      title={null}
      isFullWidthMainContent
      mobileModalPositionBottom
      desktopModalPositionCenter
      contentWrapperStyle={{
        borderRadius: isDesktop ? 24 : '16px 16px 0 0',
        padding: 0,
      }}
      headerStyle={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        height: 58,
        fontSize: '15px',
        lineHeight: '15px',
      }}
      closeButtonStyle={{
        position: 'absolute',
        left: 16,
        top: '50%',
        transform: 'translateY(-50%)',
        width: 40,
        height: 40,
      }}
      titleStyle={{
        margin: 0,
      }}
    >
      {children}
    </Modal>
  );
};
